<template>
  <div
    class="extraction-template-list-item subtitle-2"
    :class="styleClass"
  >
    <div class="etli-title-area">
      <v-icon class="mr-2" small>
        {{ getIconForType(typeName) }}
      </v-icon>
      <span class="font-weight-bold">{{ value.title }}</span>
      <div>
        <extraction-template-item-actions
          :item-style="itemStyle"
          @delete="$emit('delete-field')"
          @revert="$emit('revert-field')"
        />
      </div>
    </div>
    <span class="grey--text">{{ subtitle }}</span>
  </div>
</template>

<script>
import { DataExtractionFieldBase } from '@/models';
import { getIconForType } from '@/modules/dataExtractionFieldHelpers';
import ExtractionTemplateItemActions from './ExtractionTemplateItemActions.vue';
import { ExtractionTemplateItemStyle } from '@/enums';

export default {
  name: 'ExtractionTemplateListItem',
  components: {
    ExtractionTemplateItemActions,
  },
  props: {
    value: {
      type: DataExtractionFieldBase,
      required: true,
    },
    itemStyle: {
      type: String,
      default: ExtractionTemplateItemStyle.DEFAULT,
      validator: (val) =>
        Object.values(ExtractionTemplateItemStyle).includes(val),
    },
  },
  emits: ['delete-field', 'revert-field'],
  computed: {
    typeName() {
      return this.value.constructor.name;
    },
    showOptionList() {
      switch (this.typeName) {
        case 'DataExtractionFieldSingleSelect':
        case 'DataExtractionFieldMultipleSelect':
          return true;
      }
      return false;
    },
    subtitle() {
      if (this.showOptionList) {
        return this.value.multipleChoiceOptions?.join(', ') ?? '';
      }
      return '';
    },
    styleClass() {
      return `style-${this.itemStyle.toLowerCase()}`;
    },
  },
  methods: {
    getIconForType: getIconForType,
  },
};
</script>

<style lang="scss" scoped>
.extraction-template-list-item {
  padding: 16px 24px;
  border: 2px solid;
  border-color: rgba(0, 0, 0, 0);
  border-radius: inherit;

  &.style-new {
    border-color: var(--v-primary-base);
  }

  &.style-modified {
    background-color: var(--v-success-lighten5);
    border-color: var(--v-success-base);
  }

  &.style-deleted {
    background-color: var(--v-error-lighten5);
    border-color: var(--v-error-base);
  }
}

.etli-title-area {
  display: grid;
  grid: 'type-icon title-text action-area' / auto 1fr auto;
  align-items: center;
}
</style>
